import { TDay } from 'src/types/venue.types';
import { IOpeningTime, TEditVenueOpeningTimes } from '../VenueOpeningTimeEditModal/types';
import { UseFormSetValue } from 'react-hook-form';

const applyTimesToNextDay = (
  dayUserSelects: TDay, // Day the user has clicked apply from MONDAY
  dayToApplyTo: TDay, // The next day from dayUserSelects
  getValues: (day: TDay) => IOpeningTime[],
  setValue: UseFormSetValue<TEditVenueOpeningTimes>,
): string[] => {
  const scheduleIdsToDelete: string[] = [];
  const schedulesToApply = getValues(dayUserSelects);
  const schedulesToUpdate = getValues(dayToApplyTo);

  // If user applies empty day to another, delete all the schedules in the next day
  if (schedulesToApply.length === 0) {
    getValues(dayToApplyTo).forEach((item) => scheduleIdsToDelete.push(item.openingTimeId));
    setValue(dayToApplyTo, [], { shouldDirty: true });
  }

  // When user applies day with more schedules than the next day, overwrite current schedules and create new ones
  else if (schedulesToApply.length >= schedulesToUpdate.length) {
    const updatedSchedules = schedulesToApply.map((schedule, index): IOpeningTime => {
      const scheduleIndex = index + 1;
      if (scheduleIndex <= schedulesToUpdate.length) {
        return {
          ...schedule,
          openingTimeId: schedulesToUpdate[index].openingTimeId,
        };
      } else {
        return {
          ...schedule,
          openingTimeId: '',
        };
      }
    });

    setValue(dayToApplyTo, updatedSchedules, { shouldDirty: true });
  }

  // When user applies day which has less schedules than the next day, overwrite current schedules delete the rest
  else {
    const updatedSchedules = [];
    schedulesToUpdate.forEach((schedule, index) => {
      const scheduleIndex = index + 1;
      if (scheduleIndex <= schedulesToApply.length) {
        // Using to push to a new array so that undefined entries aren't added

        updatedSchedules.push({
          ...schedulesToApply[index],
          openingTimeId: schedule.openingTimeId,
        });
      } else {
        scheduleIdsToDelete.push(schedule.openingTimeId);
      }
    });

    setValue(dayToApplyTo, updatedSchedules, { shouldDirty: true });
  }
  return scheduleIdsToDelete;
};

export default applyTimesToNextDay;
